import { useLocation } from "react-router-dom";
import {
  useGetAllDocumentsList,
  useGetAllDocumentsRequestList,
  useGetAllDocumentsRequestListAdmin,
} from "./queries";
import {
  isDiligentAdminUserRole,
  useUserRole,
} from "../utils/helperMethods";

const VENDOR_LIBRARY_STATUSES = ["Published", "Upcoming"];

/**
 * Same Library Documents query OrgLibraryDocumentsTab uses, so Company Profile
 * Service Categories can union the capabilities shown on those cards.
 */
export function useOrgLibraryDocuments({
  orgType,
  orgId,
  isCatalogAdmin: isCatalogAdminProp,
  currentPage = 1,
  searchQuery = "",
  archiveStatusFilter = "active_only",
} = {}) {
  const isSponsorOrg = orgType === "sponsor";
  const location = useLocation();
  const userRole = useUserRole();
  const isProviderRole =
    userRole === "Provider User" || userRole === "Provider Master User";
  const isVendorPortalSelfService = location.pathname.startsWith(
    "/user/team/profile/edit"
  );
  const isCatalogAdmin =
    isCatalogAdminProp ?? isDiligentAdminUserRole(userRole);
  const useVendorOrgLibraryRequestsApi =
    !isSponsorOrg && (isProviderRole || isVendorPortalSelfService);
  const useVendorOrgLibraryDocumentsApi =
    !isSponsorOrg &&
    !useVendorOrgLibraryRequestsApi &&
    Boolean(orgId) &&
    isCatalogAdmin;

  const sponsorIdList = orgId ? [orgId] : [];

  const sponsorAdminQuery = useGetAllDocumentsRequestListAdmin(
    currentPage,
    [],
    [],
    [],
    [],
    [],
    sponsorIdList,
    searchQuery,
    {},
    0,
    isCatalogAdmin ? archiveStatusFilter : null,
    true,
    isSponsorOrg && isCatalogAdmin && Boolean(orgId)
  );

  const sponsorSelfQuery = useGetAllDocumentsRequestList(
    currentPage,
    [],
    [],
    [],
    [],
    [],
    searchQuery,
    [],
    [],
    {},
    0,
    true,
    isSponsorOrg && !isCatalogAdmin
  );

  const vendorAdminQuery = useGetAllDocumentsList(
    currentPage,
    searchQuery,
    [],
    orgId ? [orgId] : [],
    [],
    [],
    undefined,
    undefined,
    [],
    null,
    useVendorOrgLibraryDocumentsApi ? archiveStatusFilter : null,
    {},
    0,
    useVendorOrgLibraryDocumentsApi
  );

  const vendorSelfQuery = useGetAllDocumentsRequestList(
    currentPage,
    [],
    [],
    VENDOR_LIBRARY_STATUSES,
    [],
    [],
    searchQuery,
    [],
    [],
    {},
    0,
    true,
    useVendorOrgLibraryRequestsApi
  );

  const activeQuery = isSponsorOrg
    ? isCatalogAdmin
      ? sponsorAdminQuery
      : sponsorSelfQuery
    : useVendorOrgLibraryDocumentsApi
      ? vendorAdminQuery
      : vendorSelfQuery;

  const { data, isLoading, isError, error, refetch: listRefetch } =
    activeQuery;

  const isVendorProviderSelfView = useVendorOrgLibraryRequestsApi;

  const items = isSponsorOrg
    ? isCatalogAdmin
      ? data?.items ?? []
      : data?.document_request_for_sponsor?.items ?? []
    : useVendorOrgLibraryDocumentsApi
      ? data?.items ?? []
      : data?.document_request_for_provider?.items ?? [];

  const totalPages = isSponsorOrg
    ? isCatalogAdmin
      ? data?.total_pages ?? 1
      : data?.document_request_for_sponsor?.total_pages ?? 1
    : useVendorOrgLibraryDocumentsApi
      ? data?.total_pages ?? 1
      : data?.document_request_for_provider?.total_pages ?? 1;

  return {
    items,
    totalPages,
    data,
    isLoading,
    isError,
    error,
    refetch: listRefetch,
    isVendorProviderSelfView,
  };
}
